import type { AcquisitionSource } from '@busy/api';
import { useT } from '../lib/i18n';

// Single-select picker for client acquisition source (migration 0075).
// Used on NewClientModal at client creation + on ClientDetailModal for
// backfilling. Native <select> for compactness — 8 options is too many
// for chip rows but reads fine as a dropdown.
//
// Sources are an enum mirroring the CHECK constraint on
// `clients.acquisition_source`. Keeping them tight (vs free-text) so
// per-source analytics surfaces don't explode the dimension over time.

const SOURCES: AcquisitionSource[] = [
  'walkin',
  'referral',
  'instagram',
  'tiktok',
  'google',
  'yelp',
  'booking_platform',
  'other',
];

export function AcquisitionSourcePicker({
  value,
  onChange,
}: {
  value: AcquisitionSource | null;
  onChange: (next: AcquisitionSource | null) => void;
}) {
  const t = useT();
  return (
    <select
      value={value ?? ''}
      onChange={(e) => {
        const v = e.target.value;
        onChange(v === '' ? null : (v as AcquisitionSource));
      }}
      className="w-full h-11 px-3 rounded-lg border border-line bg-surface text-ink-900 dark:text-ink-100 focus:outline-none focus:ring-2 focus:ring-navy-900 dark:focus:ring-gold-500"
    >
      <option value="">{t('acquisitionSource.unspecified')}</option>
      {SOURCES.map((s) => (
        <option key={s} value={s}>
          {t(`acquisitionSource.${s}`)}
        </option>
      ))}
    </select>
  );
}
